import React, { useState, useEffect } from "react";
import { API_IP } from "../global_variables";
import axios from "axios";
import "./CareProviderProfile.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import StarRating from "./UserPatientScreen/StarRating";
import Modal from "./UserCalendarScreen/CalendarMainModal";
import { set } from "date-fns";
import { FaArrowLeft } from "react-icons/fa";
const CareProviderProfile = ({ setSelectedSection }) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isCredentialsOpen, setIsCredentialsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation(); // Curent user location for react router dom.
  const queryParams = new URLSearchParams(location.search);
  const [provider, setProvider] = useState(location.state?.data || null);
  const [loading, setLoading] = useState(!location.state?.data);
  const imgIndex = location.state?.imgIndex || 1;
  const providerName = queryParams.get("name") || "Name";
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const toggleIsRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  // Conditianlly changes the image (direction) for the arrow in the component.
  const profileArrowButton = (setValue) => {
    setValue((prev) => !prev);
  };

  useEffect(() => {
    // Nếu đã có data (do click từ trang trước), không cần làm gì cả
    if (provider) return;

    // Nếu không có data, thử lấy ID từ URL
    const idFromUrl = searchParams.get("id");

    if (idFromUrl) {
      setLoading(true);
      // Gọi API để lấy lại thông tin Provider dựa trên ID
      // LƯU Ý: Nếu backend bạn chưa có API lấy 1 provider,
      // ta có thể gọi API lấy tất cả rồi lọc (hơi thủ công nhưng chắc chắn chạy với code hiện tại của bạn)
      axios
        .get(`${API_IP}/api/providers`)
        .then((response) => {
          // Tìm provider có ID trùng khớp
          const foundProvider = response.data.find(
            (p) => (p._id || p.provider_id) == idFromUrl,
          );

          if (foundProvider) {
            setProvider(foundProvider);
          } else {
            // Không tìm thấy -> Quay về trang chủ
            navigate("/UserHome", { replace: true });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error refetching provider:", err);
          navigate("/UserHome", { replace: true });
        });
    } else {
      // Không có State, cũng không có ID trên URL -> Quay về trang chủ
      navigate("/UserHome", { replace: true });
    }
  }, [provider, searchParams, navigate]);

  const renderTextWithLineBreaks = (text) => {
    if (!text) return null;
    return text.split("(.)").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("(.)").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const parseListField = (text) =>
    (text || "")
      .split(/\n|\(\.\)/)
      .map((s) => s.trim())
      .filter(Boolean);

  const handleBackClick = () => {
    navigate(-1);
  };

  if (loading || !provider) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        <img src={require("../images/loading_icon.gif")} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      <div className="CPP-container">
        <div className="back-button-container">
          <button onClick={handleBackClick} className="profile-back-button">
            <FaArrowLeft className="back-icon" />
            <span>Back to List</span>
          </button>
        </div>

        <Modal
          showModal={showModal}
          handleClose={closeModal}
          preSelectedProvider={provider}
          toggleRefresh={toggleIsRefresh}
          setSelectedSection={setSelectedSection}
        />

        <div className="CPP-main-card">
          <div className="CPP-image-wrapper">
            <img
              src={
                provider.img_url || require(`../images/avatar_placeholder.png`)
              }
              alt={provider.provider_name}
              className="CPP-image"
            />
          </div>

          <div className="CPP-info-wrapper">
            <div className="CPP-header-info">
              <h1 className="CPP-title">{provider.provider_name}</h1>
              <h2 className="CPP-subtitle">{provider.title}</h2>
              <h3 className="CPP-slogan">{provider.slogan}</h3>
            </div>

            <button className="CPP-schedule-btn" onClick={openModal}>
              Schedule an appointment with {provider.provider_name}
            </button>
          </div>
        </div>

        <div className={`CPP-accordion-card ${isProfileOpen ? "open" : ""}`}>
          <div
            className="CPP-accordion-header"
            onClick={() => profileArrowButton(setIsProfileOpen)}
          >
            <h2 className="CPP-accordion-title">Profile</h2>
            <div className="CPP-accordion-arrow">
              <img
                className={isProfileOpen ? "rotated" : ""}
                src={require("../images/show_more_icon.png")}
                alt="Toggle"
              />
            </div>
          </div>
          <div className={`CPP-accordion-body ${isProfileOpen ? "open" : ""}`}>
            <p>{renderTextWithLineBreaks(provider.self_description)}</p>
          </div>
        </div>

        <div
          className={`CPP-accordion-card ${isCredentialsOpen ? "open" : ""}`}
        >
          <div
            className="CPP-accordion-header"
            onClick={() => profileArrowButton(setIsCredentialsOpen)}
          >
            <h2 className="CPP-accordion-title">Credentials</h2>
            <div className="CPP-accordion-arrow">
              <img
                className={isCredentialsOpen ? "rotated" : ""}
                src={require("../images/show_more_icon.png")}
                alt="Toggle"
              />
            </div>
          </div>
          <div
            className={`CPP-accordion-body ${isCredentialsOpen ? "open" : ""}`}
          >
            {(() => {
              const items = parseListField(provider.credentials);
              if (items.length === 0) {
                return <p>No credentials listed.</p>;
              }
              return (
                <ul className="CPP-credential-list">
                  {items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              );
            })()}
          </div>
        </div>

        <div className={`CPP-accordion-card ${isServicesOpen ? "open" : ""}`}>
          <div
            className="CPP-accordion-header"
            onClick={() => profileArrowButton(setIsServicesOpen)}
          >
            <h2 className="CPP-accordion-title">Services</h2>
            <div className="CPP-accordion-arrow">
              <img
                className={isServicesOpen ? "rotated" : ""}
                src={require("../images/show_more_icon.png")}
                alt="Toggle"
              />
            </div>
          </div>
          <div className={`CPP-accordion-body ${isServicesOpen ? "open" : ""}`}>
            {(() => {
              const items = Array.isArray(provider.services)
                ? provider.services.filter(Boolean)
                : [];
              if (items.length === 0) {
                return <p>No services listed.</p>;
              }
              return (
                <ul className="CPP-service-list">
                  {items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              );
            })()}
          </div>
        </div>

        <div className="CPP-review-section">
          <h2 className="CPP-section-title">Reviews</h2>
          <div className="CPP-review-body">
            {renderTextWithLineBreaks(provider.reviews_temp)}
          </div>
        </div>

        {/* <div className="CPP-similar-section">
          <h2 className="CPP-section-title">You May Also Like</h2>
          Nội dung các provider khác nếu có
        </div> */}
      </div>
    </>
  );
};

export default CareProviderProfile;
